import { EnumCtaSectionBlockBackgroundTheme } from '$/(cms)/_modules/cmsService/types';

export const backgroundClassMap: Record<
  EnumCtaSectionBlockBackgroundTheme,
  string
> = {
  [EnumCtaSectionBlockBackgroundTheme.PrimaryLight]: 'bg-fill/primary-light',
  [EnumCtaSectionBlockBackgroundTheme.SecondaryLight]:
    'bg-fill/secondary-light',
  [EnumCtaSectionBlockBackgroundTheme.Alternative_1]: 'bg-fill/alternative-1',
  [EnumCtaSectionBlockBackgroundTheme.Alternative_2]: 'bg-fill/alternative-2',
  [EnumCtaSectionBlockBackgroundTheme.Alternative_3]: 'bg-fill/alternative-3',
};
